import script from "./ArgonSelectMulti.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonSelectMulti.vue?vue&type=script&setup=true&lang=js"

import "./ArgonSelectMulti.vue?vue&type=style&index=0&id=16eeef9c&lang=scss"

const __exports__ = script;

export default __exports__